import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Signup from './Signup';
import LoginModal from './LoginModal';
import { useTranslation } from '../i18n';

interface SignupModalProps {
  show: boolean;
  onHide: () => void;
  onSignupSuccess?: () => void;
  hideCloseButton?: boolean;
}

const SignupModal: React.FC<SignupModalProps> = ({ 
  show, 
  onHide, 
  onSignupSuccess, 
  hideCloseButton = false
}) => {
  const { t } = useTranslation();
  // "Log in here" swaps this modal for the login modal (never stacked on it);
  // the login modal's "Register now" swaps back, closing it closes both
  const [showLogin, setShowLogin] = useState(false);
  const [closeAfterLogin, setCloseAfterLogin] = useState(false);
  useEffect(() => {
    if (!showLogin && closeAfterLogin) {
      setCloseAfterLogin(false);
      onHide();
    }
  }, [showLogin, closeAfterLogin, onHide]);
  useEffect(() => {
    if (!show) {
      setShowLogin(false);
    }
  }, [show]);

  const handleSignupSuccess = () => {
    if (onSignupSuccess) {
      onSignupSuccess();
    }
    onHide();
  };


  return (
    <>
    <Modal show={show && !showLogin} onHide={hideCloseButton ? undefined : onHide} centered size="lg">
      <Modal.Header closeButton={!hideCloseButton}>
        <Modal.Title>{t('auth.create_account')}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Signup 
          onSignupSuccess={handleSignupSuccess}
          onShowLogin={() => setShowLogin(true)}
        />
      </Modal.Body>
    </Modal>
    <LoginModal
      show={show && showLogin}
      onHide={() => { setShowLogin(false); setCloseAfterLogin(true); }}
      onShowSignup={() => setCloseAfterLogin(false)}
      onLoginSuccess={handleSignupSuccess}
    />
    </>
  );
};

export default SignupModal;
